import { useEffect, useState } from "react";
import { getUser } from "./API/ApiService";
import { useNavigate } from "react-router-dom";

function NouveauxMurs() {
  const [mursDisponibles, setMursDisponibles] = useState([]);
  const [chargement, setChargement] = useState(true);
  const user = getUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.role !== "USER") {
      navigate("/");
      return;
    }

    const fetchMurs = async () => {
      try {
       const mursRes = await fetch(`${process.env.REACT_APP_API_USER_URL}/MurDeBrique/nouveaux?userId=${user.id}`);
const murs = await mursRes.json();
setMursDisponibles(murs);
      } catch (err) {
        console.error("Erreur récupération des murs :", err);
      } finally {
        setChargement(false);
      }
    };

    fetchMurs();
  }, []);

  const ajouterMur = async (murAdminId) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_USER_URL}/MurDeBrique/copier/${murAdminId}?userId=${user.id}`, {
        method: "POST",
      });
      const data = await res.json();
      alert(`Mur ajouté : ${data.nom}`);
      // Optionnel : rafraîchir la liste
      setMursDisponibles(prev => prev.filter(m => m.id !== murAdminId));
    } catch (err) {
      console.error("Erreur ajout mur :", err);
      alert("Erreur lors de l’ajout.");
    }
  };

  return (
    <div className="nouveau-murs">
      <h2>Nouveaux murs disponibles</h2>
      {chargement ? (
        <p>Chargement...</p>
      ) : mursDisponibles.length === 0 ? (
        <p>Aucun nouveau mur à copier.</p>
      ) : (
        mursDisponibles.map((mur) => (
         <div key={mur.id} className="mur-card">
  <span className="mur-nom">{mur.nom}</span>
  <button className="btn-ajouter" onClick={() => ajouterMur(mur.id)}>
    Ajouter à mes murs
  </button>
</div>
        ))
      )}
    </div>
  );
}

export default NouveauxMurs;